import { connect } from 'react-redux';

import { InfoLayout, IInfoLayoutProps } from '../../components/mobile/InfoLayout';
import { IState } from '../../store';
import { getVillageOffersType } from '../../utils/getVillageOffersType';
import { getCounterSetOnSale } from '../../utils/helpers';

export function mapStateToProps(state: IState): IInfoLayoutProps {
  const { finishYearMin, finishYearMax, villageClass, counterSet = {} } = state.villageData.village;

  const { total } = counterSet;

  return {
    finishYearMin,
    finishYearMax,
    villageClass,
    total,
    totalOnSale: getCounterSetOnSale(counterSet),
    offersType: getVillageOffersType(state),
  };
}

export const InfoLayoutContainer = connect<IInfoLayoutProps>(mapStateToProps)(InfoLayout);
